<section class="page-shell">
  <header class="page-header">
    <div class="left">
      <button mat-button routerLink="/invoices/payments"><mat-icon>arrow_back</mat-icon> Payments</button>
      <div class="title-block">
        <p class="eyebrow">One-off tool</p>
        <h1>Link certain invoice payments</h1>
        <p class="subtitle">Only exact, unique revenue transaction matches are eligible.</p>
      </div>
    </div>
    <div class="right">
      <button mat-stroked-button color="primary" (click)="loadPreview()" [disabled]="isLoading || isLinking">
        <mat-icon>refresh</mat-icon> Refresh
      </button>
      <button mat-raised-button color="primary" (click)="linkAllCertainMatches()" [disabled]="isLoading || isLinking || !candidates.length">
        <mat-icon>link</mat-icon> Link {{candidates.length}}
      </button>
    </div>
  </header>

  <div class="summary">
    <div>
      <p class="label">Payments scanned</p>
      <div class="value">{{payments.length}}</div>
    </div>
    <div>
      <p class="label">Revenue transactions</p>
      <div class="value">{{transactions.length}}</div>
    </div>
    <div>
      <p class="label">Certain matches</p>
      <div class="value">{{candidates.length}}</div>
    </div>
    <div>
      <p class="label">Skipped</p>
      <div class="value">{{skippedCount}}</div>
    </div>
  </div>

  <mat-spinner *ngIf="isLoading"></mat-spinner>

  <div class="result-bar" *ngIf="linkedCount || failedCount || isLinking">
    <span>{{linkedCount}} linked</span>
    <span>{{failedCount}} failed</span>
    <mat-spinner diameter="18" *ngIf="isLinking"></mat-spinner>
  </div>

  <div class="table-card" *ngIf="!isLoading">
    <div class="empty-state" *ngIf="!candidates.length">No certain unlinked payment matches found.</div>

    <table *ngIf="candidates.length">
      <thead>
        <tr>
          <th>Invoice</th>
          <th>Customer</th>
          <th>Payment</th>
          <th>Transaction</th>
          <th>Reason</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let candidate of candidates" [class.selected-row]="isSelected(candidate)">
          <td>#{{candidate.payment.invoiceNumber}}</td>
          <td>{{getCustomer(candidate.payment) || 'No customer'}}</td>
          <td>
            <div>{{candidate.payment.payment.amount | human}}</div>
            <div class="muted">{{candidate.payment.payment.date | date:'dd-MM-yy'}}</div>
          </td>
          <td>
            <div>{{candidate.transaction.amount | human}}</div>
            <div class="muted">{{candidate.transaction.date | date:'dd-MM-yy'}}</div>
            <div class="mono">{{candidate.transaction.source.sha1}}</div>
          </td>
          <td>{{candidate.reason}}</td>
          <td>
            <span class="status" [ngClass]="candidate.status">{{candidate.status}}</span>
            <div class="error" *ngIf="candidate.error">{{candidate.error}}</div>
          </td>
          <td class="actions">
            <button mat-icon-button type="button" matTooltip="Open invoice" (click)="openInvoice(candidate)">
              <mat-icon>receipt_long</mat-icon>
            </button>
            <button mat-icon-button type="button" matTooltip="Open transaction" (click)="openTransaction(candidate)">
              <mat-icon>account_balance</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="table-card skipped-card" *ngIf="!isLoading">
    <div class="section-heading">
      <div>
        <p class="eyebrow">Skipped</p>
        <h2>Payments needing assessment</h2>
      </div>
      <div class="count">{{oneMatchSkippedPayments.length}}</div>
    </div>

    <div class="empty-state" *ngIf="!oneMatchSkippedPayments.length">No skipped payments with exactly one possible transaction.</div>

    <table *ngIf="oneMatchSkippedPayments.length">
      <thead>
        <tr>
          <th>Invoice</th>
          <th>Customer</th>
          <th>Payment</th>
          <th>Reason</th>
          <th>Possible Matches</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let skipped of oneMatchSkippedPayments" [class.linked-row]="skipped.status === 'linked'">
          <td>#{{skipped.payment.invoiceNumber}}</td>
          <td>{{getCustomer(skipped.payment) || 'No customer'}}</td>
          <td>
            <div>{{skipped.payment.payment.amount | human}}</div>
            <div class="muted">{{skipped.payment.payment.date | date:'dd-MM-yy'}}</div>
          </td>
          <td>{{skipped.reason}}</td>
          <td>
            <span class="muted">{{skipped.matches.length ? skipped.matches.length + ' same-amount' : 'None'}}</span>
          </td>
          <td class="actions">
            <button mat-icon-button type="button" matTooltip="Open invoice" (click)="openSkippedInvoice(skipped)">
              <mat-icon>receipt_long</mat-icon>
            </button>
            <button
              mat-icon-button
              type="button"
              matTooltip="Open possible transaction"
              (click)="openSkippedTransaction(skipped.matches[0])">
              <mat-icon>account_balance</mat-icon>
            </button>
            <button
              mat-icon-button
              type="button"
              matTooltip="Link payment to this transaction"
              (click)="linkSkippedPayment(skipped)"
              [disabled]="skipped.status === 'linked'">
              <mat-icon>{{skipped.status === 'linked' ? 'check' : 'link'}}</mat-icon>
            </button>
            <div class="error" *ngIf="skipped.error">{{skipped.error}}</div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</section>
